import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import { UpwardReduxInput } from "../ui";
import axios from "axios";

const TermsText = (props) => {
    const [tcpaR, setTcpaR] = useState("");
    
    let date = new Date();  
    date = date.getTime();

    useEffect(() => {

        axios.get(process.env['REACT_APP_API_URL']+"/upward/fetchOptins.jsp?_="+date).then((response) => {
            if(response.data.resp.type && response.data.resp.type === "resume"){
                setTcpaR(response.data.resp.lang);
            }
        }).catch(function (error) {
            console.log(error);
        })
    
    }, []);
    
    function createMarkup() {
        return {__html: props.termsText};
    }

    function createMarkup2() {
        return {__html: tcpaR};
    }

   	const showCarriersModal = () => {
		props.setShowRegOverlay(false);
	    props.setShowCarriers(true);
	}
    
    return (
        <div className="termsText">
            {
                ((props.page === "email" && props.overlayType !== "bookmark" && (props.hostedType.toLowerCase() !== "hosted" && props.hostedType.toLowerCase() !== "hosted_plus")) || props.page === "easyApply" || props.page === "uploadResume")
                &&
                <p className="small">
                    By clicking the button above, I agree to the <a href={`${props.redirectBaseUrl}/results/?pageNum=1&terms-and-conditions`} target="_blank" rel="noopener noreferrer">Terms of Use</a> & <a href={`${props.redirectBaseUrl}/results/?pageNum=1&privacy-policy`} target="_blank" rel="noopener noreferrer">Privacy Policy</a> and to receive email alerts and opportunities from Employers and <span className="capitalize">{props.domain}</span> at the email provided.
                </p>
            }
            {
                (props.page === "number" || props.page === "userInfo" || props.page === "almostDone" || props.page === "finishResumeUpload" || (props.page === "email" && (props.hostedType.toLowerCase() === "hosted" || props.hostedType.toLowerCase() === "hosted_plus")))
                &&
                <p className="small">
                    By clicking the button above, I agree to the <span className="capitalize">{props.domain}</span> <a href={`${props.redirectBaseUrl}/results/?pageNum=1&terms-and-conditions`} target="_blank" rel="noopener noreferrer">Terms of Use</a> & <a href={`${props.redirectBaseUrl}/results/?pageNum=1&privacy-policy`} target="_blank" rel="noopener noreferrer">Privacy Policy</a> and to receive SMS, texts, job alerts, and opportunities from Employers and <span className="capitalize">{props.domain}</span> at the phone number provided above or in my resume. I agree to receive SMS notifications from our <a onClick={showCarriersModal}>participating carriers</a> and may receive up to 5 messages per day (message frequency may vary). Text HELP for help. Text STOP to cancel. Message and data rates may apply.
                </p>
            }
            {
                (props.page === "easyApply" || props.page === "uploadResume" || props.page === "finishResumeUpload")
                &&
                <p className="small">
                    I understand that my resume will be added to the resume database and that Employers and <span className="capitalize">{props.domain}</span> may contact me regarding career opportunities.
                </p>
            }
            {
                props.page === "email"
                &&
                <p className="small" dangerouslySetInnerHTML={createMarkup()}></p>
            }
            {
                (props.page === "uploadResume" || props.page === "uploadFile" || props.page === "easyApply")
                &&
                <p className="resumeOptinAdd small" dangerouslySetInnerHTML={createMarkup2()}></p>
            }
        </div>
    )
}

export default TermsText;